import * as React from 'react';
import { useState } from 'react';
import styled from 'styled-components';
import { Checkbox, Dialog, Button, Typography } from '@beeline.com/bp-design-system';
import { useDarkly } from 'integrations/launchDarkly/legacy/useDarkly';
import { TutorialsProvider } from './TutorialsContext';
import { TUTORIAL_KEY, useTutorials } from './useTutorials';
import { useTutorialsIntl } from './translations/useTutorialsIntl';
import { useTutorialsTemplate } from './useTutorialsTemplate';

export const Tutorials: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const tutorials = useTutorials();
  const { disableTutorials } = useDarkly();
  const disabled = disableTutorials || window.localStorage.getItem(TUTORIAL_KEY);
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const { okButton, dontShow } = useTutorialsIntl();
  const allTutorials = useTutorialsTemplate();
  const activeTutorial = tutorials.activeTutorial ? allTutorials[tutorials.activeTutorial] : null;

  const onCloseDialog = React.useCallback(() => {
    tutorials.closeTutorial!(tutorials.activeTutorial!, dontShowAgain);
  }, [tutorials.closeTutorial, tutorials.activeTutorial, dontShowAgain]);

  return (
    <TutorialsProvider value={tutorials}>
      {children}
      {!disabled && activeTutorial && (
        <Dialog onClose={onCloseDialog} open={!!tutorials.openTutorial} maxWidth={false}>
          <StyledContent>
            <div>
              <img src={activeTutorial!.img} alt="Tutorial" />
            </div>
            <StyledInfo>
              <Typography variant="h2" dataTest="tutorial-header">
                {activeTutorial!.heading}
              </Typography>
              {activeTutorial!.sections.map((section) => (
                <Typography variant="body1" dataTest={`tutorial-section-${section.key}`} key={section.key}>
                  {section.message}
                </Typography>
              ))}
              <StyledActions>
                <Checkbox
                  dataTest="tutorial-checkbox"
                  checked={dontShowAgain}
                  onChange={() => setDontShowAgain(!dontShowAgain)}
                  dashStyle={false}
                  dense={false}
                  disabled={false}
                  labelPlacement="end"
                >
                  {dontShow}
                </Checkbox>
                <Button dataTest="tutorial-confirm" variant="contained" color="primary" onClick={onCloseDialog}>
                  {okButton}
                </Button>
              </StyledActions>
            </StyledInfo>
          </StyledContent>
        </Dialog>
      )}
    </TutorialsProvider>
  );
};
const StyledInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacingSize.l};
`;
const StyledActions = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: auto;
`;
const StyledContent = styled.div`
  display: flex;
  width: 800px;
  padding: ${({ theme }) => theme.spacingSize.xxl};
  gap: ${({ theme }) => theme.spacingSize.xxl};

  img {
    max-width: 400px;
  }
  > div {
    flex: 1;
  }
`;
